import { render, staticRenderFns } from "./WebPortal.vue?vue&type=template&id=42eda395&"
import script from "./WebPortal.vue?vue&type=script&lang=js&"
export * from "./WebPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports